import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { CatalogUerBaseCostWorkScopeUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { updateCatalogUERBaseCostWorkScopesGql } from '../../../catalogUerBaseCostQueries';

const requestId = 'updateCatalogUERBaseCostWorkScopes';

interface IRequest {
    uerBaseCostId: number;
    inputs: CatalogUerBaseCostWorkScopeUpdateInput[];
}

export const useUpdateCatalogUERBaseCostWorkScopes = (onSuccess: () => void) => {
    const dispatch = useDispatch();

    const [updateCatalogUERBaseCostWorkScopesReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        updateCatalogUERBaseCostWorkScopesReset(undefined);
        onSuccess();
    }, [updateCatalogUERBaseCostWorkScopesReset, onSuccess]);

    const [, updateCatalogUERBaseCostWorkScopesStatus, , updateCatalogUERBaseCostWorkScopesRequest] = useRequest({
        requestId,
        query: updateCatalogUERBaseCostWorkScopesGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const updateCatalogUERBaseCostWorkScopesDoRequest = useCallback(
        (props: IRequest) => {
            dispatch(updateCatalogUERBaseCostWorkScopesRequest(props));
        },
        [dispatch, updateCatalogUERBaseCostWorkScopesRequest],
    );

    useEffect(() => {
        updateCatalogUERBaseCostWorkScopesReset(undefined);
    }, [updateCatalogUERBaseCostWorkScopesReset]);

    return {
        request: updateCatalogUERBaseCostWorkScopesDoRequest,
        status: updateCatalogUERBaseCostWorkScopesStatus,
    };
};
